var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F9F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0666 33.4983C21.8438 33.4983 18.6211 33.4983 15.3983 33.4983C15.2409 33.4983 15.0814 33.4983 14.9233 33.4823C14.1165 33.4085 13.7921 32.8758 14.1362 32.1555C14.4347 31.5336 14.7604 30.9277 15.0767 30.3125C16.5695 27.4158 18.0624 24.5196 19.5552 21.6238C19.6014 21.5354 19.6495 21.4469 19.7031 21.3624C20.0791 20.7718 20.6898 20.6887 21.1709 21.1982C21.5102 21.5547 21.7972 21.955 22.0999 22.3415C23.6379 24.3114 25.176 26.2823 26.7141 28.2541C27.3859 29.112 28.2321 29.1586 29.0213 28.3871C29.4128 28.004 29.7955 27.6109 30.1918 27.2312C30.9063 26.5461 31.7172 26.5874 32.3008 27.3861C33.472 28.989 34.614 30.6131 35.7615 32.232C35.8512 32.359 35.9199 32.499 35.9651 32.647C36.0763 33.0188 35.9189 33.318 35.5342 33.4171C35.2929 33.4738 35.0453 33.4999 34.7972 33.495C31.5555 33.5003 28.3119 33.5014 25.0666 33.4983Z",
    fill: "#D4D2E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.294 17.626C32.2932 18.2443 32.1051 18.8484 31.7535 19.3617C31.402 19.8751 30.9028 20.2746 30.3193 20.5096C29.7359 20.7446 29.0943 20.8044 28.4761 20.6816C27.8579 20.5588 27.2908 20.2589 26.8467 19.8198C26.4026 19.3807 26.1015 18.8222 25.9816 18.2152C25.8618 17.6082 25.9285 16.98 26.1733 16.4102C26.4182 15.8404 26.8301 15.3546 27.3569 15.0146C27.8838 14.6745 28.5017 14.4955 29.1325 14.5001C29.9725 14.5105 30.7746 14.8441 31.366 15.4288C31.9574 16.0136 32.2907 16.8027 32.294 17.626Z",
    fill: "#D4D2E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaceholder);
export default __webpack_public_path__ + "static/media/Icon-Placeholder.62e7d48be5f326668b4169878a600141.svg";
export { ForwardRef as ReactComponent };